// import { initColorMode } from "./theme/colorMode"; // TODO: activate Darkmode

import changeEventForInput from "./helper/autofill-events";

import { scrollToID } from "./helper/helper";
import {
  initToggleDropdown,
  disableEmptyNavLinks,
  initAccessibilityToggle,
  initMobileFirstLevelMenu,
} from "./partials/mb-navigation";
import { initNavIcon } from "./partials/mb-nav-icon";
import { initContactNav } from "./partials/mb-nav-contact";
import { initMbModal } from "./partials/mb-modal";
import { initMbPopup } from "./partials/mb-popup";
import { configLibraries } from "./theme/configLibraries";
import { linkWrapperClickHandler, initWatchHover } from "./theme/clickHandler";
import { initMobileHover } from "./partials/mb-mobile-hover";
import { initReadmore, updateReadMore } from "./partials/mb-readmore";
import { initMbFormSelect, initMbInputFocus } from "./partials/mb-form";
// import { mbYoutubeBorlabsGate } from "./partials/mb-youtube-borlabs-gate";

import { printDeveloperMessageToConsole } from "./helper/mbagentur";
import { initEmployeeSlider } from "./partials/mb-single-employee";
import { initReferencesSlider } from "./partials/mb-single-reference";
import { initContactFormModal } from "./partials/mb-contactform-modal";

import { createAnimatedDotDiv } from "./partials/mb-animated-dot";

import setVideoControlsList from "./helper/video-controls-list";

/**
 * Init JS Helper
 */
changeEventForInput();

(function () {
  function init() {
    // // Get styling informations from css property values
    // const style = getComputedStyle(document.body);
    // const max_mainwidth = style.getPropertyValue("--maxMainWidth");

    // // TODO: activate Darkmode
    // initColorMode();

    initNavIcon();
    initContactNav();
    initToggleDropdown();
    disableEmptyNavLinks();
    initAccessibilityToggle();
    initMobileFirstLevelMenu();
    configLibraries();
    linkWrapperClickHandler();
    initWatchHover();
    initEmployeeSlider();
    initMobileHover();
    initReferencesSlider();
    initMbModal();
    initMbPopup();
    initReadmore();
    initContactFormModal();
    createAnimatedDotDiv();
    setVideoControlsList();
    initMbInputFocus();
    initMbFormSelect();
    // mbYoutubeBorlabsGate();

    printDeveloperMessageToConsole();
  }

  init();

  // On document ready
  // docReady(function (context) {});
})();

/**
 * Remove page loader
 */
jQuery(window).on("load", function () {
  // document.addEventListener("DOMContentLoaded", function () {
  jQuery(".mb-loader-wrapper").fadeOut("slow");
});

/**
 * Smooth Anker scrolling
 */
jQuery('a[href*="#"]').on("click", function (e) {
  const target = this.hash;
  if (scrollToID(target, -50)) {
    e.preventDefault();
  }
});

/**
 * Document resize listener
 */
window.addEventListener("resize", (event) => {
  updateReadMore();
});

/**
 * When the user scrolls down, hide the navbar.
 * When the user scrolls up, show the navbar
 */
let prevScrollpos = window.scrollY;
const pagenavi = document.getElementById("mb-section-main-menu");
// const anchorNavi = document.querySelector(".com-anchors");

if (pagenavi) {
  document.addEventListener("scroll", () => {
    let currentScrollPos = window.scrollY;

    if (Math.abs(prevScrollpos - currentScrollPos) > window.innerHeight * 0.2) {
      if (prevScrollpos > currentScrollPos) {
        pagenavi.style.top = "0";
        // if (anchorNavi) anchorNavi.style.top = pagenavi.offsetHeight + "px";
      } else {
        pagenavi.style.top = "-" + pagenavi.offsetHeight + "px";
        // if (anchorNavi) anchorNavi.style.top = "0";
      }

      prevScrollpos = currentScrollPos;
    }
  });
}
